import React from 'react'
import {AdminDefaultMediumButton, PPButtonProps} from '../../../styledComponents/adminPage/Buttons'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'

const PPErrorDisplayButton: React.FC<PPButtonProps & ErrorHandlingFormProps> = props => {
    const {
        messages, hint, hasError, clearErrorMessage, eventEmitter, eventKeys, clearError,
        ...rest
    } = props
    return (
        <AdminDefaultMediumButton
            {...rest}
            onClick={(event) => {
                if (clearErrorMessage) {
                    clearErrorMessage()
                }
                if (props.onClick) {
                    props.onClick(event)
                }
            }}
        >
            {props.children}
        </AdminDefaultMediumButton>
    )
}
PPErrorDisplayButton.displayName = 'PPErrorDisplayButton'
export default createErrorHandlingForm(PPErrorDisplayButton)
